export default __webpack_public_path__ + "static/media/peonies-preview.566e2434.jpg";